import { useEffect, useState } from 'react';

import { Spin } from 'antd';
import { loading } from './Loading.Styles';
import useDeviceWidth from '../../hooks/useDeviceWidth';
import { utils } from '../../utils';

const css = `.ant-spin-dot-item {
  background-color: #282820 !important;
  color: black;
  width: 300px;
  height: 300px;
  
}`

function Loading({ message }) {
    const deviceWidth = useDeviceWidth();
    const [styles, setStyles] = useState(utils.getDeviceStyles(loading, deviceWidth));
    useEffect(() => {
        setStyles(utils.getDeviceStyles(loading, deviceWidth));
    }, [deviceWidth])
    const content = <div style={styles.content} />;
    return (
        <div style={styles.container}>
            <Spin size="large">
                <style>{css}</style>
                {
                    content
                }
            </Spin>
            <h1 style={styles.message}>{message}</h1>
        </div>
    )
}

export default Loading;